import { Icons } from "types/CMS/KontentAI/taxonomies/icons";
import { createResolver } from "../Factories/ResolverFactory";
import { Elements } from "@kontent-ai/delivery-sdk";
import { IconName } from "assets/icons/UnumSync";

export const nameToComponentName = (name: string, joiner: string = "-") => {
  return (
    name.charAt(0).toUpperCase() +
    name
      .slice(1)
      .replace(new RegExp(`${joiner}([a-z])`, "g"), (match, letter) =>
        letter.toUpperCase()
      )
      .replace(new RegExp(`${joiner}(\\d)`, "g"), (match) => match[1])
  );
};

export const iconReslover = createResolver({
  resolve: (icon: Elements.TaxonomyElement<Icons, "icon">): IconName => {
    const iconURL = nameToComponentName(icon.value[0].codename, "_");
    return iconURL as IconName;
  },
});